import { observable } from 'mobx';
import { ExpensesAllocationViewModel } from 'chaika-types';

export class ExpensesAllocationStore {
    public static Name = 'expensesAllocationStore' as const;

    public static makeTitleAndSubTitle({
        purposeOfPayment,
        expenditure,
        counterparty,
    }: Pick<ExpensesAllocationViewModel, 'purposeOfPayment' | 'counterparty' | 'expenditure'>): {
        title: string;
        subTitle: string;
    } {
        return {
            title: purposeOfPayment,
            subTitle: `${expenditure}
${counterparty}`,
        };
    }

    @observable public expensesAllocations: ExpensesAllocationViewModel[] = [];

    public get availableExpensesAllocations(): ExpensesAllocationViewModel[] {
        return this.expensesAllocations.filter(({ availableAmaunt }) => availableAmaunt > 0);
    }
}

export const expensesAllocationStore = new ExpensesAllocationStore();
